import { gql } from "@apollo/client";

const DELETE_KNOWLEDGE_SOURCE = gql`
  mutation DeleteKnowledgeSource($sourceId: String!) {
    deleteKnowledgeSource(sourceId: $sourceId) {
      success
      error
    }
  }
`;

export default DELETE_KNOWLEDGE_SOURCE;
